import { render, staticRenderFns } from "./orderWxshenpiKill.vue?vue&type=template&id=3bc4e722&scoped=true"
import script from "./orderWxshenpiKill.vue?vue&type=script&lang=js"
export * from "./orderWxshenpiKill.vue?vue&type=script&lang=js"
import style0 from "./orderWxshenpiKill.vue?vue&type=style&index=0&id=3bc4e722&prod&scoped=true&lang=css"
import style1 from "./orderWxshenpiKill.vue?vue&type=style&index=1&id=3bc4e722&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc4e722",
  null
  
)

export default component.exports